/**
 * Anomaly detection debug logger.
 * Toggled by VITE_DEBUG_ANOMALY env var (true | false).
 * Production builds tree-shake all DEBUG-gated branches because the constant
 * resolves to `false` and Vite eliminates dead code.
 */
const DEBUG = import.meta.env.VITE_DEBUG_ANOMALY === 'true';

const ts = () => new Date().toISOString().slice(11, 23);

export const log = {
  /** Network request out / response in. */
  net: (label: string, data?: unknown) => {
    if (DEBUG) console.log(`%c[${ts()}] 📡 NET ${label}`, 'color:#0a7', data ?? '');
  },
  /** SocketIO connection / room / event. */
  sock: (label: string, data?: unknown) => {
    if (DEBUG) console.log(`%c[${ts()}] 🔌 SOCK ${label}`, 'color:#a07', data ?? '');
  },
  /** FSM state transition. */
  fsm: (action: string, oldStatus: string, newStatus: string, payload?: unknown) => {
    if (DEBUG) console.log(`%c[${ts()}] ⚙️ FSM ${oldStatus}→${newStatus} via ${action}`, 'color:#07a', payload ?? '');
  },
  /** User interaction (button click, file pick). */
  click: (label: string, ctx?: unknown) => {
    if (DEBUG) console.log(`%c[${ts()}] 🖱️ CLICK ${label}`, 'color:#a70', ctx ?? '');
  },
  /** Hook lifecycle event (mount, effect, cleanup). */
  hook: (hookName: string, event: string, data?: unknown) => {
    if (DEBUG) console.log(`%c[${ts()}] 🪝 ${hookName}: ${event}`, 'color:#777', data ?? '');
  },
  /** Errors — always logged regardless of DEBUG flag. */
  err: (where: string, error: unknown) => {
    console.error(`[${ts()}] 🔴 ERR ${where}`, error);
  },
  /** Whether logging is currently enabled. */
  enabled: DEBUG,
};
